import { get, post, patch, del } from './client.js';

export const orgDeveloperApi = {
  // API Keys — /orgs/:orgId/developer/api-keys
  listKeys:    (orgId)           => get(`/orgs/${orgId}/developer/api-keys`),
  generateKey: (orgId, data)     => post(`/orgs/${orgId}/developer/api-keys`, data),
  rotateKey:   (orgId, keyId)    => post(`/orgs/${orgId}/developer/api-keys/${keyId}/rotate`),
  revokeKey:   (orgId, keyId)    => del(`/orgs/${orgId}/developer/api-keys/${keyId}`),

  // OAuth Apps — /orgs/:orgId/developer/oauth-apps
  listOAuthApps:  (orgId)          => get(`/orgs/${orgId}/developer/oauth-apps`),
  createOAuthApp: (orgId, data)    => post(`/orgs/${orgId}/developer/oauth-apps`, data),
  deleteOAuthApp: (orgId, appId)   => del(`/orgs/${orgId}/developer/oauth-apps/${appId}`),

  // Webhooks — /orgs/:orgId/developer/webhooks
  listWebhooks:        (orgId)                  => get(`/orgs/${orgId}/developer/webhooks`),
  createWebhook:       (orgId, data)            => post(`/orgs/${orgId}/developer/webhooks`, data),
  updateWebhook:       (orgId, webhookId, data) => patch(`/orgs/${orgId}/developer/webhooks/${webhookId}`, data),
  testWebhook:         (orgId, webhookId)       => post(`/orgs/${orgId}/developer/webhooks/${webhookId}/test`),
  deleteWebhook:       (orgId, webhookId)       => del(`/orgs/${orgId}/developer/webhooks/${webhookId}`),
  getWebhookDeliveries:(orgId, webhookId)       => get(`/orgs/${orgId}/developer/webhooks/${webhookId}/deliveries`),

  // Secrets — /orgs/:orgId/developer/secrets
  listSecrets:   (orgId)           => get(`/orgs/${orgId}/developer/secrets`),
  createSecret:  (orgId, data)     => post(`/orgs/${orgId}/developer/secrets`, data),
  deleteSecret:  (orgId, secretId) => del(`/orgs/${orgId}/developer/secrets/${secretId}`),

  // Logs
  getLogs: (orgId) => get(`/orgs/${orgId}/developer/logs`),

  // External Applications
  listExternalApps:   (orgId)               => get(`/orgs/${orgId}/developer/apps`),
  createExternalApp:  (orgId, data)         => post(`/orgs/${orgId}/developer/apps`, data),
  getExternalApp:     (orgId, appId)        => get(`/orgs/${orgId}/developer/apps/${appId}`),
  updateExternalApp:  (orgId, appId, data)  => patch(`/orgs/${orgId}/developer/apps/${appId}`, data),

  // External Credentials
  listExternalCredentials:        (orgId, appId)              => get(`/orgs/${orgId}/developer/apps/${appId}/credentials`),
  createExternalCredential:       (orgId, appId, data)        => post(`/orgs/${orgId}/developer/apps/${appId}/credentials`, data),
  revokeExternalCredential:       (orgId, appId, credId)      => post(`/orgs/${orgId}/developer/apps/${appId}/credentials/${credId}/revoke`),
  updateExternalCredentialExpiry: (orgId, appId, credId, data)=> patch(`/orgs/${orgId}/developer/apps/${appId}/credentials/${credId}`, data),

  // External Workspace Grants
  listWorkspaceGrants:  (orgId, appId)                    => get(`/orgs/${orgId}/developer/apps/${appId}/workspaces`),
  grantWorkspace:       (orgId, appId, data)              => post(`/orgs/${orgId}/developer/apps/${appId}/workspaces`, data),
  updateWorkspaceGrant: (orgId, appId, workspaceId, data) => patch(`/orgs/${orgId}/developer/apps/${appId}/workspaces/${workspaceId}`, data),
  revokeWorkspaceGrant: (orgId, appId, workspaceId)       => del(`/orgs/${orgId}/developer/apps/${appId}/workspaces/${workspaceId}`),
};
